import type {
  MechanicalInspection as MechanicalInspectionType,
  MechanicalInspectionAvailable,
} from '@/types';
import {
  Core,
  MECHANICAL_INSPECTION,
  MECHANICAL_INSPECTION_AVAILABLE,
} from '../Core';

class MechanicalInspection extends Core {
  getMechanicalInspection = async (id: number, barCode: string | number) =>
    this.get<MechanicalInspectionType>(MECHANICAL_INSPECTION(id, barCode));

  getMechanicalInspectionAvailable = async (
    id: number,
    barCode: string | number,
  ) =>
    this.get<MechanicalInspectionAvailable>(
      MECHANICAL_INSPECTION_AVAILABLE(id, barCode),
    );
}

export const mechanicalInspection = new MechanicalInspection();
